import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, DownloadIcon, FileTextIcon, MonitorSmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-8 md:py-12 px-6 bg-[#FFF0F3]" data-id="element-266">
      <div className="max-w-4xl mx-auto" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-pink-100 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-268">
          <div className="flex-1 w-full relative" data-id="element-269">
            <div className="absolute -top-4 -left-4 bg-[#C41E3A] text-white text-xs md:text-sm font-bold px-4 py-2 rounded-full shadow-lg -rotate-3 z-10" data-id="element-270">
              Oferta por Lanzamiento
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/cBSMPU4vmAjJtUkxETdg6a/mockup_-_Desconexion_Emocional_en_dispositivos_digitales.png" alt="Mockup Desconexión Emocional" className="w-full h-auto drop-shadow-xl" data-id="element-271" />
          </div>

          <div className="flex-1 w-full text-center md:text-left" data-id="element-272">
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-warmBrown mb-4" data-id="element-273">
              ¡Accede Hoy a Tu Guía!
            </h2>

            <div className="flex items-center justify-center md:justify-start gap-4 mb-6" data-id="element-274">
              <span className="text-2xl text-gray-400 line-through font-medium" data-id="element-275">
                $25.00
              </span>
              <span className="text-5xl font-bold text-[#C41E3A]" data-id="element-276">
                $6.99 <span className="text-xl" data-id="element-277">USD</span>
              </span>
            </div>

            <div className="mb-8 text-left" data-id="element-278">
              <p className="font-bold text-warmBrown mb-4" data-id="element-279">Incluye:</p>

              <div className="mt-6 space-y-3" data-id="element-280">
                {[{
                icon: FileTextIcon,
                text: 'Formato digital descargable (PDF)'
              }, {
                icon: MonitorSmartphoneIcon,
                text: 'Compatible con todos los dispositivos'
              }, {
                icon: ShieldCheckIcon,
                text: 'Garantía de satisfacción 7 días'
              }].map((benefit, i) => <motion.div key={i} className="flex items-center gap-3" initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: i * 0.1
              }} data-id="element-281">
                    <benefit.icon className="w-5 h-5 text-[#8B2252] flex-shrink-0 stroke-[1.5]" data-id="element-282" />
                    <span className="text-sm text-warmBrown font-medium" data-id="element-283">
                      {benefit.text}
                    </span>
                  </motion.div>)}
              </div>
            </div>

            <CTAButton text="QUIERO ACCEDER AHORA" icon={<ZapIcon className="w-5 h-5" data-id="element-285" />} href="https://pay.hotmart.com/E104809825H" data-id="element-284" />
          </div>
        </motion.div>
      </div>
    </section>;
}